import { ChangeEvent, useEffect, useState } from 'react';
import ActionsGroup from '../../../juristec-ui/core/ActionsGroup';
import Button from '../../../juristec-ui/core/Button';
import InputNumberLine from '../../../juristec-ui/core/InputNumberLine';
import {
  MainContainer,
  PresetContainer,
  OptionGroup,
  Option,
} from './styled';

interface GridFixedSizeProps {
  savedSize?: number | 'auto';
  close: () => void;
  submit: (value: number | string) => void;
}

const DashGridSize = ({
  savedSize, close, submit,
}: GridFixedSizeProps) => {
  const [sizingType, setSizingType] = useState<'fixed' | 'auto'>(
    savedSize && savedSize !== 'auto' ? 'fixed' : 'auto',
  );
  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);
  const [size, setSize] = useState<number>(
    savedSize && savedSize !== 'auto' ? savedSize : window.innerWidth,
  );

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleSize = (value: number) => {
    setSize(value);
  };

  const handleSizeEvt = (e: ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.target.value);
    setSize(value > 0 ? value : 1);
  };

  const handleSubmit = () => submit(sizingType === 'auto' ? 'auto' : size);

  return (
    <>
      <MainContainer>
        <OptionGroup>
          <Option
            onClick={() => setSizingType('auto')}
            active={sizingType === 'auto'}
          >
            Largura dinâmica
          </Option>
          <Option
            onClick={() => setSizingType('fixed')}
            active={sizingType === 'fixed'}
          >
            Largura fixa
          </Option>
        </OptionGroup>
        {sizingType === 'fixed' && (
          <>
            <InputNumberLine
              // @ts-expect-error not typed yet
              label="Tamanho em pixels"
              value={size}
              onChange={handleSizeEvt}
              setValue={handleSize}
              min={1}
            />
            <h5 style={{ margin: '10px 0 5px 0' }}>
              Sugestões:
            </h5>
            <PresetContainer>
              <Button
                size="small"
                textTransform="none"
                variant="outlined"
                color="info"
                onClick={() => setSize(screenWidth)}
              >
                {`Tela atual\n${screenWidth}px`}
              </Button>
              <Button
                size="small"
                textTransform="none"
                variant="outlined"
                color="info"
                onClick={() => setSize(5120)}
              >
                {'Ultrawide\n5120px'}
              </Button>
              <Button
                size="small"
                textTransform="none"
                variant="outlined"
                color="info"
                onClick={() => setSize(3840)}
              >
                {'4K\n3840px'}
              </Button>
              <Button
                size="small"
                textTransform="none"
                variant="outlined"
                color="info"
                onClick={() => setSize(2560)}
              >
                {'2K\n2560px'}
              </Button>
              <Button
                size="small"
                textTransform="none"
                variant="outlined"
                color="info"
                onClick={() => setSize(1920)}
              >
                {'Full HD\n1920px'}
              </Button>
              <Button
                size="small"
                textTransform="none"
                variant="outlined"
                color="info"
                onClick={() => setSize(1280)}
              >
                {'HD\n1280px'}
              </Button>
            </PresetContainer>
          </>
        )}
      </MainContainer>
      <ActionsGroup>
        <Button
          style={{ margin: '5px' }}
          onClick={close}
          variant="outlined"
          size="large"
        >
          Cancelar
        </Button>
        <Button
          style={{ margin: '5px' }}
          onClick={handleSubmit}
          size="large"
          // disabled={name.error}
        >
          Salvar
        </Button>
      </ActionsGroup>
    </>
  );
};

export default DashGridSize;
